import { GuideCompleted, GuideStep } from 'types/tour';

import { GuideType } from 'constants/enums';

interface GuideSettings {
  guideStep: GuideStep;
  userUpdate: GuideCompleted;
}

export const getGuidePagesSettings = (
  guideType: GuideType,
  guideCompleted: GuideCompleted
): GuideSettings => {
  const guideSettingsMap: Record<GuideType, GuideSettings> = {
    [GuideType.FullGuide]: {
      guideStep: {
        dismissGuide: true,
        jobsGuide: guideCompleted.jobsGuideCompleted || false,
        applicationsGuide: guideCompleted.applicationsGuideCompleted || false,
        jobseekersGuide: guideCompleted.jobseekersGuideCompleted || false
      },
      userUpdate: { dismissGuide: true }
    },
    [GuideType.Jobs]: {
      guideStep: {
        dismissGuide: guideCompleted.dismissGuide || false,
        jobsGuide: true,
        applicationsGuide: guideCompleted.applicationsGuideCompleted || false,
        jobseekersGuide: guideCompleted.jobseekersGuideCompleted || false
      },
      userUpdate: {
        jobsGuideCompleted: true,
        ...(guideCompleted.dismissGuide !== undefined && {
          dismissGuide: guideCompleted.dismissGuide
        })
      }
    },
    [GuideType.Applications]: {
      guideStep: {
        dismissGuide: true,
        applicationsGuide: true,
        jobsGuide: guideCompleted.jobsGuideCompleted || false,
        jobseekersGuide: guideCompleted.jobseekersGuideCompleted || false
      },
      userUpdate: { applicationsGuideCompleted: true }
    }
  };

  return guideSettingsMap[guideType];
};
